import { render, staticRenderFns } from "./UsagesTable.vue?vue&type=template&id=ccdd3084&scoped=true"
import script from "./UsagesTable.vue?vue&type=script&lang=js"
export * from "./UsagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdd3084",
  null
  
)

export default component.exports